// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__KXvas","container":"styles_container__SXtF6","slideInSearchBar":"styles_slideInSearchBar__PBmfA"};